import { useEffect, useState } from "react";
import { Bell } from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { api } from "../lib/api";
import { fmtDateTime } from "../lib/format";

export const NotificationBell = ({ dark = false }) => {
  const [data, setData] = useState({ items: [], unread: 0 });
  const nav = useNavigate();
  const loc = useLocation();
  const load = () => api.get("/notifications").then((r) => setData(r.data)).catch(() => {});
  useEffect(() => {
    load();
    const t = setInterval(load, 60000);
    return () => clearInterval(t);
  }, [loc.pathname]);
  const onOpen = (o) => {
    if (o && data.unread) api.post("/notifications/read-all").then(() => setData((d) => ({ ...d, unread: 0 })));
  };
  return (
    <Popover onOpenChange={onOpen}>
      <PopoverTrigger asChild>
        <button data-testid="notification-bell" className={`relative rounded-lg p-2 ${dark ? "text-slate-200 hover:bg-slate-800" : "text-slate-600 hover:bg-slate-100"}`}>
          <Bell className="h-5 w-5" />
          {data.unread > 0 && (
            <span data-testid="notification-count" className="absolute -right-0.5 -top-0.5 grid h-5 min-w-5 place-items-center rounded-full bg-emerald-500 px-1 text-[10px] font-bold text-white">
              {data.unread}
            </span>
          )}
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-80 p-0">
        <div className="border-b px-4 py-3 font-heading font-semibold">Notifications</div>
        <div className="max-h-96 overflow-y-auto">
          {data.items.length === 0 && <p className="p-6 text-center text-sm text-slate-500">No notifications yet</p>}
          {data.items.map((n) => (
            <button key={n.id} onClick={() => n.link && nav(n.link)} data-testid={`notification-item-${n.id}`}
              className={`block w-full border-b px-4 py-3 text-left hover:bg-slate-50 ${n.read ? "" : "bg-emerald-50/50"}`}>
              <p className="text-sm font-semibold text-slate-800">{n.title}</p>
              <p className="text-xs text-slate-600">{n.message}</p>
              <p className="mt-1 text-[11px] text-slate-400">{fmtDateTime(n.created_at)}</p>
            </button>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
};
